
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Produtos extends Vue {
    model = 0;
    loading = false;
    selection = 1;
    items = [
        {
          src: "/vendas/SLIDE1.png",
        },
        {
          src: "/vendas/SLIDE2.png",
        }
    ];

    reserve() {
      this.loading = true;
      setTimeout(() => (this.loading = false), 2000);
    }
}
